// extracted by mini-css-extract-plugin
module.exports = {"Steps":"Steps--2mie4","Form":"Form--PrnhC","Title":"Title--32U-r","SubTitle":"SubTitle--sLcJs","Submit":"Submit--2ofZz"};